<template>
  <div>
    <v-autocomplete
      ref="t1"
      v-bind="$attrs"
      v-on="$listeners"
      :items="items"
      hide-selected
      multiple
      small-chips
      filled
      dense
      :value="iValue"
      @change="clearSearch"
      :search-input.sync="searchInput"
    ></v-autocomplete>
  </div>
</template>

<script>
  import RefreshOnDemand from '@/components/codelist/mixins/RefreshOnDemand'
  export default {
    name: 'SiteSelect',
    mixins: [
      RefreshOnDemand,
    ],
    data: function () {
      return {
        searchInput: undefined,
      }
    },
    computed: {
      key () {
        return 'sites'
      },
    },
    methods: {
      clearSearch () {
        this.searchInput = ''
      },
    },
  }
</script>

<style scoped>

</style>
